import { TAB_RECOIL_BUCKET } from '@/shared/config';
import { getDataState } from './dbState';

let isUndoRedo = false;
/**
 * Marks whether an undo or redo is currently being applied. Assigns the module-level flag.
 *
 * @param value - New value of the undo or redo in-progress flag.
 * @returns Nothing.
 */
export const setIsUndoRedo = (value: boolean) => {
  isUndoRedo = value;
};
/**
 * Reports whether the change currently being persisted originated from an undo or redo. Returns the module-level flag as it stands.
 *
 * @returns True while an undo or redo is being applied.
 */
export const getIsUndoRedo = () => isUndoRedo;

/**
 * Resolves which report tab and child tab are active so an undo entry can restore the view. Reads the persisted activeTab value, maps it through KEY_RECOIL to the matching activeTabState key, and falls back to ARTIFACT for tab 1 or VE_COUPLET for tab 2 when no child tab is stored.
 *
 * @returns A promise resolving to an object carrying activeTab and activeTabChild.
 */
export const getPositionActive = async () => {
  let activeTab: any = await getDataState('activeTab');
  activeTab = activeTab?.value; // Default to '1' if activeTab is undefined

  const activeTabState = `activeTabState-${TAB_RECOIL_BUCKET[activeTab as keyof typeof TAB_RECOIL_BUCKET]}`;
  let activeTabChild;
  if (activeTab !== undefined) {
    activeTabChild = (await getDataState(activeTabState)) as any;
    const defaultActiveTabMap: Record<number, string> = {
      1: 'ARTIFACT',
      2: 'VE_COUPLET',
    };
    // Default to '1' if activeTabChild is undefined
    activeTabChild = activeTabChild?.value || defaultActiveTabMap[activeTab];
  }

  const position = {
    activeTab,
    activeTabChild, // Use map if available, otherwise use the value
  };
  return position;
};
